/* KFC custom sort dropdown — visual replacement for the native <select>
   that matches the Corals header submenu styling. Click an option →
   updates the underlying hidden <select> and fires `change`, so Dawn's
   facet-filters-form (or the auction-today safety-net page reload) still
   handles the navigation. */
class KfcSort extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    this._init = true;

    this.trigger = this.querySelector('.kfc-sort__trigger');
    this.menu    = this.querySelector('.kfc-sort__menu');
    this.current = this.querySelector('[data-kfc-sort-current]');
    this.options = Array.from(this.querySelectorAll('.kfc-sort__menu li'));
    // The hidden <select> sits right after this custom element in the DOM.
    this.select  = this.parentElement && this.parentElement.querySelector('select.facet-filters__sort');

    this.trigger.addEventListener('click', () => this.toggle());
    this.options.forEach(opt => {
      opt.addEventListener('click', () => this.choose(opt));
      opt.addEventListener('keydown', e => this.onOptionKey(e, opt));
    });
    document.addEventListener('click', e => { if (!this.contains(e.target)) this.close(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); });
  }

  toggle() {
    (this.trigger.getAttribute('aria-expanded') === 'true') ? this.close() : this.open();
  }

  open() {
    this.trigger.setAttribute('aria-expanded', 'true');
    this.menu.hidden = false;
    const sel = this.options.find(o => o.getAttribute('aria-selected') === 'true') || this.options[0];
    if (sel) sel.focus();
  }

  close() {
    this.trigger.setAttribute('aria-expanded', 'false');
    this.menu.hidden = true;
  }

  choose(opt) {
    const value = opt.dataset.value;
    const name = opt.dataset.name || opt.textContent.trim();
    this.options.forEach(o => o.removeAttribute('aria-selected'));
    opt.setAttribute('aria-selected', 'true');
    if (this.current) this.current.textContent = name;
    this.close();
    this.trigger.focus();
    if (this.select && this.select.value !== value) {
      this.select.value = value;
      // Dawn's facet-filters-form binds to `input` (debounced) on the form,
      // not `change`. Programmatically assigning select.value fires neither
      // event natively, so we have to dispatch both: `input` triggers Dawn's
      // AJAX re-render, `change` lets the auction-today safety-net (which
      // listens for change in capture phase) intercept and force a full
      // page reload on the auction collection.
      this.select.dispatchEvent(new Event('input', { bubbles: true }));
      this.select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  onOptionKey(e, opt) {
    const i = this.options.indexOf(opt);
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.choose(opt);
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      const next = this.options[Math.min(i + 1, this.options.length - 1)];
      if (next) next.focus();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      const prev = this.options[Math.max(i - 1, 0)];
      if (prev) prev.focus();
    }
  }
}
if (!customElements.get('kfc-sort')) customElements.define('kfc-sort', KfcSort);
